import { get } from 'lodash';
import { isRequestCancelation } from 'Common/Helpers';

import { CLEAR_STATE, REQUEST_CANCELED, CANCEL_REQUEST } from './types';

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const loading = (type, isLoading, cancelable, source) => {
  return {
    type,
    payload: isLoading,
    cancelable,
    source,
  };
};

export const success = (type, payload) => {
  return { type, payload };
};

export const error = (type, payload) => {
  return { type, payload };
};

export const reset = (type, payload) => {
  return { type, payload };
};

export const set = (type, payload) => {
  return { type, payload };
};

/**
 * Takes in the loading action type of the request to be canceled
 * @example
 * cancelRequest('GET_NUTRTION_FACTS_LOADING')
 */
export const cancelRequest = (type) => {
  return {
    type: CANCEL_REQUEST,
    payload: type,
    cancelable: true,
  };
};

/**
 * Creates a thunk clone with the USER key added
 * Our custom thunk middleware captures this applies the correct API to use for the thunk
 * @param {Function} thunk
 * @param {Object} user
 */
export const withApiOverride = (thunk, user) => {
  /** create a clone of the thunk, so we don't modify the existing */
  const clonedThunk = thunk.bind();
  /** Functions are "Objects", therefore we can still set a key on a function */
  clonedThunk.USER = user;
  return clonedThunk;
};

/**
 * HOW TO USE:

  // actions.js
  export const test = model => (dispatch, getState, MPWWebAPI) => {
    // MPWWebAPI will have the correct headers with
    // the authenticated user passed into the withApiOverride
  };

  // Component.js or actions.js
    dispatch(
      requestAccess({
        onError: console.log,
        onUser: user => {
          const model = {
            days: 123,
            data: '456'
          };
          dispatch(
            withApiOverride(test(model), user)
          );
        },
        title: 'Would you like to unclose day?',
      })
    )
 */

/**
 * MPWebApiError
 * @typedef {Object} MPWebApiError
 * @property {string} Title - Title
 * @property {string} Message - Message
 */

export const DEFAULT_ERROR = {
  Title: 'Error',
  Message: 'An error occurred while retrieving the data.',
};
/**
 * Generic method that handles exceptions thrown on an API request by converting
 * it into the error action.
 *
 * @param {Object} exception the exception thrown by the API request
 * @param {String} type the error type
 * @param {MPWebApiError|MPWebApiError[]} defaultErrorMsg the default error object to fallback to with the form { Title: ..., Message: ... }
 */
export const handleErrorException = (
  exception,
  type,
  defaultErrorMsg = DEFAULT_ERROR
) => {
  /** Request was canceled */
  if (isRequestCancelation(exception)) {
    const payload = {
      message: exception.message,
      type,
    };
    return error(REQUEST_CANCELED, payload);
  }

  const errorList = get(exception, 'response.data.Errors');

  if (errorList && errorList.length > 0) {
    if (errorList.length > 1) {
      return error(type, errorList);
    }
    return error(type, errorList[0]);
  } else {
    return error(type, defaultErrorMsg);
  }
};



// WEBPACK FOOTER //
// ./src/state/actions.js